import Footer from "@/components/Footer";
import Navigation from "@/components/Navigation";
export default function MaintenanceandSupportPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <section className="pt-20 bg-white relative overflow-hidden">
        <section className="relative bg-[#184fb8] after:absolute after:inset-0 after:opacity-20 after:bg-[radial-gradient(#f3f4f6_1px,transparent_1px)] after:bg-[16px_16px] after:z-50">
          <div className="container mx-auto px-6 py-14 lg:py-20 text-white relative z-20">
            <h1 className="text-4xl md:text-5xl font-black">
              Technical Support
            </h1>
            <p className="mt-4 max-w-3xl text-white/90">
              Tech Suppport Services helps businesses, organizations or
              individuals to maintain their website or services. Variable soft
              offers 24*7*365 Tech Support to their clients to keep their
              operations running smoothly. We provide support via email, online
              chats, phone calls etc. We have a technical team to help you.
            </p>
          </div>
        </section>
        <main className="container mx-auto px-6 py-12 lg:py-16 grid gap-10 lg:grid-cols-3">
          <article className="lg:col-span-2 space-y-6 text-slate-700 leading-7">
            <p className="reveal">
              Variable soft provides All India based Tech Support Solutions for
              your businesses. We manage users’ website maintenance that can run
              perfectly, also handle software repairing services, product
              listing of any shopping cart websites etc.
            </p>
            <p className="reveal">
              Search engine loves website which is frequently updated, and
              always place on the top of search. Your website needs constant
              updation to look fresh. Customers come at those websites who have
              latest and exciting information. We are here to help you keeping
              your website fresh and active.
            </p>
            <p className="reveal">
              Variablesoft provides professional Website maintenance services
              that ensure best return on investment. We help our clients to
              support &amp; retain their clients and their products. We are
              always suited to give the best to our clients through high
              quality, customized, scalable and competitive solutions to match
              your needs.
            </p>
            <p className="reveal">
              With experience of Service Providers and Software development in
              Jaipur, India, we are well known for the best technical support
              services. Our Tech Support Team assist our clients regarding any
              other technical, installation software or any other technical
              issues.
            </p>
            <p className="reveal">
              Simply you just need to send us your requirements by email, call
              or through online chat, our technical team will analyze your
              requirements and will get back to you with a perfect solution.
            </p>
          </article>

          <aside className="space-y-8">
            <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_12px_32px_rgba(2,6,23,.10)]">
              <h3 className="text-lg font-bold text-slate-900">Services</h3>
              <ul className="mt-4 divide-y divide-slate-100">
                <li>
                  <a className="block py-3 hover:text-brand-700" href="/webdesign">
                    Web Design
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-brand-700" href="/software-development-in-jaipur">
                    Web Development
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-brand-700" href="/ecommerce-development-services">
                    Ecommerce
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-brand-700" href="/top-software-companies-in-jaipur">
                    Mobile Application
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-brand-700" href="/it-companies-in-jaipur">
                    Digital Marketing
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-brand-700" href="/web-scraping-services">
                    Web Scraping
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-brand-700" href="/maintenanceandsupport">
                    Maintenance And Support
                  </a>
                </li>
              </ul>
            </section>
          </aside>
        </main>
      </section>
      <Footer />
    </div>
  );
}
